import React from 'react'

const TotalsIndicator = ({value, style, onSelectFilter }) => {
    if(!value || value == 0)
        return <div className={'fex-center'}>
            <i className={'fa fa-minus'} aria-hidden="true" />
        </div>

    return <div className={`wl-item ${style} fex-center`} onClick={ onSelectFilter }>
        {value}
    </div>
}

export default TotalsIndicator